module.exports = __webpack_public_path__ + "static/media/formas_adequadas.7ab13612.jpg";